import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  card: {
    borderRadius: "10px",
    backgroundColor: theme.palette.secondary.light,
    padding: "10px",
    width: "280px",
    border: `2px solid ${theme.palette.secondary.main}`,
  },
  taskDetails: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  taskName: {
    fontSize: "16px",
    fontWeight: 600,
    textAlign: "center",
  },
  dateAndPriority: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: "gray",
  },
  flexCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  chipAndPopupContainer: {
    maxWidth: "100px",
    textAlign: "left",
    position: "relative",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "5px",
  },
  chip: {
    fontSize: "14px",
    minWidth: "20px",
    cursor: "pointer",
  },
  popUp: {
    marginTop: "0px",
    position: "absolute",
    cursor: "auto",
    zIndex: "10 !important",
  },
}));

export default useStyles;
